import QueryString from 'qs';
import { TGridFocusStorage } from '../../../components/apia/execution/fields/apiaDataGrid/ApiaDataGrid';
import persistentStorage from '../../../utils/persistentStorage';
import { noNaN } from '../../../utils/util';
import { addRowBoundary } from '../../selection/setNewFocused';
import { TBasicRow } from '../../selection/types';
import { IDataGridContext, TDataColumn, IDataGridSlice } from '../types';
import { Draft } from '@reduxjs/toolkit';

export default function restoreFocusAfterReload(
  state: Draft<Record<string, IDataGridSlice<string | TBasicRow, TDataColumn>>>,
  context: IDataGridContext,
  id: string,
) {
  let url = window.location.search;
  if (url.startsWith('?')) url = url.slice(1);
  const urlData = QueryString.parse(url);
  if (
    urlData.action === 'fireFieldEvent' &&
    urlData.fldId === String(context.grid.field.id) &&
    urlData.frmId === String(context.form.formData.id) &&
    urlData.frmParent === context.form.frmParent
  ) {
    const storedData = (
      (persistentStorage.gridFocus ?? {}) as Record<
        string,
        TGridFocusStorage | undefined
      >
    )[id];
    if (!storedData) {
      console.error('There is no gridFocus data');
    } else {
      state[id].isGridFocused = true;
      state[id].focusedColumn = storedData.focusedColumn;
      const grid = state[id].context.grid.field;
      const { paged: isPaged } = grid.properties;
      const currentPage = noNaN(grid.curPage);
      console.log({ urlData, storedData, currentPage });

      let hasHandledPaged = false;
      if (isPaged && urlData.gridAction !== 'add') {
        if (storedData?.currentPage < currentPage) {
          state[id].focusedRow = 0;
          hasHandledPaged = true;
        } else if (storedData.currentPage > currentPage) {
          state[id].focusedRow = state[id].rows.length - 1;
          hasHandledPaged = true;
        }
      }
      if (!hasHandledPaged) {
        switch (urlData.gridAction) {
          case 'add':
            state[id].focusedRow = state[id].rows.length - 1;
            break;
          case 'delete':
            state[id].focusedRow = addRowBoundary(
              storedData.focusedRow,
              state[id],
            );
            break;
          case 'down':
            state[id].focusedRow = addRowBoundary(
              storedData.focusedRow + 1,
              state[id],
            );
            break;
          case 'up':
            state[id].focusedRow = addRowBoundary(
              storedData.focusedRow - 1,
              state[id],
            );
            break;
          default:
            break;
        }
      }
      state[id].selectedRows = [state[id].focusedRow];
    }
  }
  persistentStorage.gridFocus = null;
}
